import { useTranslation } from "react-i18next";
import EsimFeature1 from "../../../../assets/images/body/esim_featured_icon_1.svg";
import EsimFeature2 from "../../../../assets/images/body/esim_featured_icon_2.svg";
import EsimFeature3 from "../../../../assets/images/body/esim_featured_icon_3.svg";
import EsimImage from "../../../../assets/images/body/featured_2esim.png";

import OrderImage from "../../../../assets/images/body/featured_order.png";
import OrderFeature1 from "../../../../assets/images/body/order_featured_icon_1.svg";
import OrderFeature2 from "../../../../assets/images/body/order_featured_icon_2.svg";
import Ordereature3 from "../../../../assets/images/body/order_featured_icon_3.svg";

import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

import { Title } from "../../../../components";
import { useLayout } from "../../../../context/LayoutContext";
import styles from "./style.module.scss";

const FeaturedSection = () => {
  const { getPadding } = useLayout();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const PROJECT_LIST = [
    {
      title: t("featured.esim.title"),
      key_features: [
        { desc: t("featured.esim.desc1"), img: EsimFeature1 },
        { desc: t("featured.esim.desc2"), img: EsimFeature2 },
        { desc: t("featured.esim.desc3"), img: EsimFeature3 },
      ],
      subtitle: t("featured.esim.subtitle"),
      desc: t("featured.esim.desc"),
      buttonDisable: false,
      url: "https://www.2esim.net/",
      img: EsimImage,
    },
    {
      title: t("featured.order.title"),
      key_features: [
        { desc: t("featured.order.desc1"), img: OrderFeature1 },
        { desc: t("featured.order.desc2"), img: OrderFeature2 },
        { desc: t("featured.order.desc3"), img: Ordereature3 },
      ],
      subtitle: t("featured.order.subtitle"),
      desc: t("featured.order.desc"),
      buttonDisable: true,
      url: "",
      img: OrderImage,
    },
    //featured.esim.title
    //     featured.esim.desc1
    // featured.esim.desc2
    // featured.esim.desc3
    // featured.esim.title
    // featured.esim.subtitle
  ];

  const renderProjects = () => {
    return PROJECT_LIST.map((_project: any) => {
      return (
        <div key={_project.title} className={styles.projectContainer}>
          <text className={styles.projectTitle}>{_project.title}</text>
          <div className={styles.keyFeatureContainer}>
            {_project.key_features.map((_keyFeature: any) => {
              return (
                <div className={styles.keyContainer} key={_keyFeature.desc}>
                  <img
                    src={_keyFeature.img}
                    alt={_keyFeature.desc}
                    className={styles.keyImage}
                  />
                  <text className={styles.keyText}>{_keyFeature.desc}</text>
                </div>
              );
            })}
          </div>
          <div className={styles.contentContainer}>
            <div className={styles.subContainer}>
              <text className={styles.subtitle}>{_project.subtitle}</text>
              <text className={styles.desc}>{_project.desc}</text>
              <Button
                className={`${styles.button} ${
                  _project.buttonDisable ? styles.disable : ""
                }`}
                disabled={_project.buttonDisable}
                icon={<RightOutlined />}
                iconPosition={"end"}
                onClick={() => window.open(_project.url)}
              >
                {_project.buttonDisable
                  ? t("normal.comingsoon")
                  : t("normal.learnmore")}
              </Button>
            </div>
            <img
              src={_project.img}
              alt={_project.title}
              className={styles.featureImage}
            />
            <Button
              className={`${styles.button1024} ${
                _project.buttonDisable ? styles.disable : ""
              }`}
              disabled={_project.buttonDisable}
              icon={<RightOutlined />}
              iconPosition={"end"}
              onClick={() => window.open(_project.url)}
            >
              {_project.buttonDisable
                ? t("normal.comingsoon")
                : t("normal.learnmore")}
            </Button>
          </div>
        </div>
      );
    });
  };

  return (
    <div className={styles.outerContainer}>
      <div
        className={styles.featuredContainer}
        id="featured"
        style={{ paddingLeft: getPadding() }}
      >
        <Title
          text={t("menu.featured")}
          shadowText={t("featured.shadow")}
          containerStyle={styles.featureTitleContainer}
          shadowStyle={styles.featureTitleShadow}
          titleStyle={styles.featureTitle}
        />
        {renderProjects()}
      </div>
    </div>
  );
};

export default FeaturedSection;
